<template>
  <v-container id="facturas-provee-table" fluid>
    <base-material-card color="#ac8a2e" icon="mdi-file-clock-outline" inline class="px-5 py-3" title="Facturas">
      <template v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewFacturaForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-file-clock-outline
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="facturas.data"
        :sort-by="sortby"
        :sort-desc="sortdesc"
        multi-sort
        @update:options="getData($event)"
        @click:row="getPagosByFactura"
      >
        <template v-slot:[`item.totalS`]="{ item }" @click="getPagosByFactura">
          <span> {{ simboloMoneda(item.moneda_id) + ' ' + item.total }} </span>
        </template>
        <template v-slot:[`item.saldoS`]="{ item }" @click="getPagosByFactura">
          <span> {{ simboloMoneda(item.moneda_id) + ' ' + item.saldo }} </span>
        </template>
      <!-- En desarrollo
        <template v-if="$can('M_parametros')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        -->
      </v-data-table>
    </base-material-card>
    <base-material-card v-if="menuPagos" color="#ac8a2e" icon="mdi-text-box-multiple" inline class="px-5 py-3" title="Pagos">
      <template v-slot:after-title>
        <v-btn
          color="error"
          fab
          dark
          small
          @click="menuPagos = false"
        >
          <v-icon color="white">
            mdi-close
          </v-icon>
        </v-btn>
      </template>
      <v-data-table
        :headers="headersPagos"
        :items="pagos"
        multi-sort
      >
        <template #item="{ item }">
          <tr>
            <td class="text-start">
              {{ item.fecha }}
            </td>
            <td>
              {{ item.jugador ? item.jugador.fullName : '' }}
            </td>
            <td>
              {{ item.staff ? item.staff.fullName : '' }}
            </td>
            <td>
              {{ item.contacto ? item.contacto.nombre + ' (' + item.contacto.razon_social + ')' : '' }}
            </td>
            <td>
              {{ montoMoneda(item) }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    name: 'Facturasapagar',
    components: {
      confirm,
    },
    data () {
      return {
        buscar: '',
        menuPagos: false,
        headers: [
          { text: 'Fecha vencimiento', value: 'fecha_vencimiento' },
          { text: 'Número', value: 'numero' },
          { text: 'Proveedor', value: 'nombre' },
          { text: 'Total', value: 'totalS' },
          { text: 'Saldo', value: 'saldoS' },
          // { text: 'Acciones', value: 'actions', sortable: false, align: 'end' }, // en desarrollo
        ],
        headersPagos: [
          { text: 'Fecha', value: 'fecha' },
          { text: 'Jugador', value: 'jugador.fullName' },
          { text: 'Staff', value: 'nombre' },
          { text: 'Otros', value: 'totalS' },
          { text: 'Monto', value: 'monto' },
        ],
        editedIndex: -1,
        facturas: [],
        pagos: [],
        sortby: [],
        sortdesc: [],
        options: {
          itemsPerPage: 5,
        },
        monedas: [],
      }
    },
    computed: {
    },
    watch: {
      buscar () {
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => this.readDataFromAPI(1, this.options.itemsPerPage), 1500)
      },
    },
    created () {
      this.getMoneda()
    },
    methods: {
      getData (data) {
        this.readDataFromAPI(data.page, data.itemsPerPage, data.sortBy, data.sortDesc)
      },

      getPagosByFactura: async function (item) {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pagosByFactura/' + item.id }).then(response => {
          this.pagos = response
          this.menuPagos = true
        })
      },

      readDataFromAPI: async function (page = 1, itemsPerPage = 5, sortBy, sortDesc) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/factura-proveedor' + '?page=' + page + '&itemsPerPage=' + itemsPerPage + '&filtro=' + this.buscar + '&sortBy=' +
            (sortBy.length ? sortBy : 'fecha') + '&sortDesc=' +
            (sortDesc.length ? sortDesc : true),
        }).then(response => {
          this.facturas = response
          this.loading = false
        })
      },

      goToNewFacturaForm (modeVal, idFac) {
        this.$router.push({ name: 'Alta factura', params: { facturaid: idFac, mode: modeVal } })
      },

      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },

      simboloMoneda (monedaId) {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === monedaId).simbolo : '$'
      },

      montoMoneda (item) {
        return (item.moneda.simbolo + ' ' + item.monto)
      },

      editItem (item) {
        this.editedIndex = this.contactos.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function (item) {
        /*
        await this.$http.delete('/api/contactos/' + item.id,
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Contacto eliminado exitosamente'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getContactos()
        */
      },
    },
  }
</script>
